import type { ReactNode } from 'react';
import { useEffect } from 'react';
import useDocumentTitle from './useDocumentTitle';
import { usePageTopBar } from 'components/PageTopBar/page-top-bar.context';

type TopBarProps = {
  stringTitle: string;
  nodeTitle?: ReactNode;
  documentTitle?: string;
};

export const useTopBar = ({ stringTitle, nodeTitle, documentTitle }: TopBarProps) => {
  const { setStringTitle, setNodeTitle } = usePageTopBar();

  useEffect(() => {
    if (stringTitle && stringTitle.length) {
      setStringTitle(stringTitle);
    }

    if (nodeTitle) {
      setNodeTitle(nodeTitle);
    } else {
      setNodeTitle(undefined);
    }
  }, [stringTitle, nodeTitle]);

  useDocumentTitle({ title: documentTitle ?? stringTitle });
};
